import form from '@wwdev/forms';
import Zipcode from '@wwdev/zipcode';

form.init('form:not(.novalidate)');
Zipcode.init();

jQuery('.field-with-other input[type=radio]').on('change', function(){
	if(jQuery(this).val().toLowerCase() == 'anders') {
		jQuery(this).parent().parent().parent().find('input[type=text]').prop('disabled', false)
	} else {
		jQuery(this).parent().parent().parent().find('input[type=text]').prop('disabled', true)
	}
});